const initialState = {}

const appendedLeagues = (leagues, league) => {
  const newLeague = { id: league.id, name: league.name, photo_url: league.photo_url }
  return [ newLeague, ...leagues ]
}

const updatedLeagues = (leagues, league) => {
  const index = leagues.findIndex(l => l.id == league.id)
  const updatedLeague = { id: league.id, name: league.name, photo_url: league.photo_url }
  return [
    ...leagues.slice(0, index), 
    updatedLeague,
    ...leagues.slice(index + 1, leagues.length)
  ]
}

const leagues = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'LEAGUES.INIT':
      return {...state, ...payload, loading: false}
    case 'LEAGUES.TRIGGER_PAST':
      return {...state, closed: payload}
    case 'LEAGUES.SEARCH':
      return {...state, query: payload}
    case 'LEAGUES.CREATE':
      return {...state, leagues: appendedLeagues(state.leagues, payload)}
    case 'LEAGUES.UPDATE':
      return {...state, leagues: updatedLeagues(state.leagues, payload)}
    case 'LEAGUES.RECEIVED':
      return {...state, ...payload, loading: false}
    case 'LEAGUES.SET_LOADING':
      return {...state, loading: true}
    default:
      return state
  }
}

export default leagues
